var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{directives:[{name:"show",rawName:"v-show",value:(!_vm.$user.isLogged),expression:"!$user.isLogged"}],staticClass:"button is-primary",attrs:{"to":{ name: 'auth', query: { redirect: _vm.redirect } }}},[_vm._t("default",function(){return [_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Login")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }